
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_lm6vo_dslii_13",
  "root-no-scroll": "awsui_root-no-scroll_lm6vo_dslii_20",
  "layout": "awsui_layout_lm6vo_dslii_25",
  "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_dslii_31",
  "layout-main": "awsui_layout-main_lm6vo_dslii_35",
  "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_dslii_41",
  "unfocusable": "awsui_unfocusable_lm6vo_dslii_46",
  "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_dslii_50",
  "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_dslii_55",
  "content-wrapper": "awsui_content-wrapper_lm6vo_dslii_59",
  "content-overlapped": "awsui_content-overlapped_lm6vo_dslii_63",
  "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_dslii_67"
};
  